import { render } from "./BenefitByRFC.vue?vue&type=template&id=32fecd6e&scoped=true"
import script from "./BenefitByRFC.vue?vue&type=script&lang=js"
export * from "./BenefitByRFC.vue?vue&type=script&lang=js"

import "./BenefitByRFC.vue?vue&type=style&index=0&id=32fecd6e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fecd6e"]])

export default __exports__